import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";
import BreadcrumbBar from "./components/BreadcrumbBar";

function ForexMajors() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const pairs = [
    { label: "EUR/USD", path: "/forex-majors/eurusd-ai-trading-predictions" },
    { label: "GBP/USD", path: "/forex-majors/gbpusd-ai-trading-predictions" },
    { label: "USD/JPY", path: "/forex-majors/usdjpy-ai-trading-predictions" },
    { label: "USD/CHF", path: "/forex-majors/usdchf-ai-trading-predictions" },
    { label: "USD/CAD", path: "/forex-majors/usdcad-ai-trading-predictions" },
    { label: "AUD/USD", path: "/forex-majors/audusd-ai-trading-predictions" },
    { label: "NZD/USD", path: "/forex-majors/nzdusd-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("forexMajors.pageTitle")}
        description={t("forexMajors.pageDesc")}
        canonical="/forex-majors"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.forexMajors"), path: "/forex-majors" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.forexMajors") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("forexMajors.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("forexMajors.pageDesc")}</p>
      <Row>
        {pairs.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
    </>
  );
}

export default ForexMajors;
